import {DojoDeshi} from './DojoDeshi.js';
import {DojoTemplates} from './DojoTemplates.js';
import {Eventify} from './Eventify.js';
import signals from './lib/signals.js';

import {FormGenerator} from './formal/FormGenerator.js';

export class FormsTabPanel {
	constructor(appendTab, name, title, jsDefinition, jsData, saveData) {
		let [el, $] = DojoTemplates('FormsTabPanel');
		this.$ = $;
		console.log("FormsTabPanel, definition = ", jsDefinition);
		if (null==jsDefinition) {
			jsDefinition = {
				'Name': 'new',
				'Title':'unnamed form',
				'fields':[{'name':'f','title':'unnamed field'}],
			}
		};

		let id = `form-${name}`;
		this.$.a.href=`#${id}`;
		this.$.a.textContent = title;
		this.$.panel.id = id;

		appendTab(this.$.panel, title);

		new FormGenerator(this.$.panel, jsDefinition, jsData, saveData);
	}
}

window.FormsTabPanel = FormsTabPanel;